import React, { useState, useEffect, useCallback } from 'react';
import apiService from '../../apiService';
import { useLiveRefresh } from '../../liveRefresh';

const STATUS = {
  confirmed: { bg: '#fee9e2', color: '#ea580c', label: 'Confirmée' },
  in_progress: { bg: '#fef3c7', color: '#ca8a04', label: 'En cours' },
  completed: { bg: '#ECFDF5', color: '#10B981', label: 'Terminée' },
  cancelled: { bg: '#fecaca', color: '#dc2626', label: 'Annulée' },
  no_show: { bg: '#F4F5F7', color: '#5C636E', label: 'Absent' },
};
const PAY = { paid: 'Payé', deposit_paid: 'Acompte', pending_on_site: 'Sur place', refunded: 'Remboursé', partially_refunded: 'Remb. partiel', cancelled: 'Annulé' };

export default function BeautyBookingsPage() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const qs = status ? `?status=${status}` : '';
      const res = await apiService.get(`/beauty/bookings${qs}`, { userType: 'admin' });
      if (res.success) setBookings(res.bookings || []);
    } catch (e) { console.error('beauty bookings', e); }
    finally { setLoading(false); }
  }, [status]);
  useEffect(() => { load(); }, [load]);
  useLiveRefresh(() => load(), ['beauty_booking']);

  const fmt = (d) => new Date(d).toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

  return (
    <div style={{ padding: '1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem', flexWrap: 'wrap', gap: '0.75rem' }}>
        <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#1E2229' }}>💇 Réservations Beauté</h2>
        <select value={status} onChange={(e) => setStatus(e.target.value)} style={{ padding: '0.5rem 0.8rem', borderRadius: 10, border: '1px solid #E9EBEF' }}>
          <option value="">Tous les statuts</option>
          {Object.keys(STATUS).map((k) => <option key={k} value={k}>{STATUS[k].label}</option>)}
        </select>
      </div>

      {loading ? <p style={{ color: '#5C636E' }}>Chargement…</p> : bookings.length === 0 ? (
        <p style={{ color: '#5C636E' }}>Aucune réservation.</p>
      ) : (
        <div style={{ overflowX: 'auto', background: '#fff', borderRadius: 14, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 800 }}>
            <thead>
              <tr style={{ background: '#FFFFFF', textAlign: 'left', fontSize: '0.8rem', color: '#5C636E' }}>
                <th style={th}>RDV</th><th style={th}>Salon</th><th style={th}>Client</th><th style={th}>Services</th><th style={th}>Montant</th><th style={th}>Paiement</th><th style={th}>Statut</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((b) => {
                const st = STATUS[b.status] || STATUS.confirmed;
                return (
                  <tr key={b.booking_id} style={{ borderTop: '1px solid #F4F5F7', fontSize: '0.85rem' }}>
                    <td style={td}>{fmt(b.start_at)}</td>
                    <td style={td}>{b.salon_name}</td>
                    <td style={td}>{b.client_name}{b.client_phone ? <div style={{ color: '#9AA0A8', fontSize: '0.75rem' }}>{b.client_phone}</div> : null}</td>
                    <td style={td}>{(b.services || []).map((s) => s.name).join(', ')}{b.at_home ? ' · 🏠' : ''}</td>
                    <td style={td}>{Number(b.price_breakdown?.total_amount || 0).toLocaleString('fr-FR')} CDF</td>
                    <td style={td}>{PAY[b.payment_status] || b.payment_status}</td>
                    <td style={td}><span style={{ background: st.bg, color: st.color, padding: '0.2rem 0.6rem', borderRadius: 10, fontSize: '0.78rem', fontWeight: 600 }}>{st.label}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const th = { padding: '0.75rem 1rem', fontWeight: 700 };
const td = { padding: '0.75rem 1rem', color: '#1E2229', verticalAlign: 'top' };
